var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BuildingPage',{attrs:{"title":"导出记录","description":"导出记录页预留任务状态、下载结果和失败重试等能力，等待导出接口接入。"}})
}
var staticRenderFns = []

export { render, staticRenderFns }